import React from "react";
import { Box, Inline, Drawer } from "braid-design-system";
import CashierSignOn from "../pages/CashierSignOn";
import CashierSignOff from "../pages/CashierSignOff";
import CashierGuard from "../guards/CashierGuard";
import { useCashier } from "../contexts/CashierProvider";


const CashierSignInOff: React.FC = () => {
    const [cashierDrawerOpen, setCashierDrawerOpen] = React.useState(false);
    const { isSignedIn, cashBook } = useCashier();

    return (
        <>
            <CashierGuard>
                <Box cursor="pointer" aria-label="Cashier Status" onClick={() => {
                    setCashierDrawerOpen(true);
                }}>
                    <Inline alignY="center" space="small">
                        {/* Cash Book Info */}
                        {cashBook ? (
                            <Box display="flex" alignItems="flexEnd" justifyContent="center" style={{ gap: '6px' }}>
                                {/* Safe / Cashbox SVG Icon */}
                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg" style={{ color: '#ffffff' }}>
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                </svg>
                                <span className="cashier-text-hide-mobile" style={{ color: '#ffffff', fontSize: '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'inline-flex', alignItems: 'flex-end', lineHeight: '1' }}>
                                    {cashBook.cash_book_name}
                                </span>
                            </Box>
                        ) : (
                            <Box display="flex" alignItems="flexEnd" justifyContent="center" style={{ gap: '6px' }}>
                                {/* Cash/Money SVG Icon representing cashier role */}
                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg" style={{ color: '#cbd5e1' }}>
                                    <line x1="12" y1="1" x2="12" y2="23"></line>
                                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                                </svg>
                                <span className="cashier-text-hide-mobile" style={{ color: '#cbd5e1', fontSize: '13px', fontWeight: 500, display: 'inline-flex', alignItems: 'flex-end', lineHeight: '1' }}>
                                    Cash Drawer
                                </span>
                            </Box>
                        )}

                        {/* Sign In / Sign Off Lock Indicator Icon */}
                        {isSignedIn ? (
                            <Box display="flex" alignItems="center" title="Signed In" style={{ cursor: 'pointer' }}>
                                {/* Unlocked Lock (Green) */}
                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg" style={{ color: '#10b981' }}>
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                                </svg>
                            </Box>
                        ) : (
                            <Box display="flex" alignItems="center" title="Signed Off" style={{ cursor: 'pointer' }}>
                                {/* Locked Lock (Red) */}
                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg" style={{ color: '#ef4444' }}>
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                            </Box>
                        )}
                    </Inline>
                </Box>

                <Drawer
                    title={"Cashier SIGN IN/OFF"}
                    open={cashierDrawerOpen}
                    width={"medium"}
                    onClose={() => setCashierDrawerOpen(false)}
                >
                    <Box padding="small">
                        {isSignedIn ? <CashierSignOff setCashierDrawerOpen={setCashierDrawerOpen} /> : <CashierSignOn setCashierDrawerOpen={setCashierDrawerOpen} />}
                    </Box>
                </Drawer>
            </CashierGuard>
        </>
    );
};

export default CashierSignInOff;
